import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  code: null,
  discountAmount: 0,
  breakdown: null,
  details: null, // { discount_type, discount_value }
  status: 'idle', // idle | applying | applied | failed
  error: null,
  message: null, // SUCCESS MESSAGE
};

const couponSlice = createSlice({
  name: 'coupon',
  initialState,
  reducers: {
    applyCouponOptimistic(state, action) {
      state.status = 'applying';
      state.code = action.payload.code;
    },
    applyCouponSuccess(state, action) {
      state.status = 'applied';
      state.breakdown = action.payload.breakdown;
      state.details = action.payload.details ?? null;
      state.discountAmount = action.payload.breakdown.discount_amount;
      state.message = action.payload.message;
      state.error = null;
    },
    applyCouponFailure(state, action) {
      state.status = 'failed';
      state.code = null;
      state.discountAmount = 0;
      state.breakdown = null;
      state.details = null;
      state.error = action.payload;
      state.message = null;
    },
    clearMessage(state) {
      state.message = null;
      state.error = null;

      // Reset transient UI state
      // if (state.status === 'applied' || state.status === 'failed') {
      if (state.status === 'failed') {
        state.status = 'idle';
      }
    },
    removeCoupon() {
      return initialState;
    },
  },
});

export const {
  applyCouponOptimistic,
  applyCouponSuccess,
  applyCouponFailure,
  clearMessage,
  removeCoupon,
} = couponSlice.actions;

export default couponSlice.reducer;
